module.exports = __webpack_public_path__ + "files/cbded7ba861baeb95681f2cb44b8f15b.png";